import { render, staticRenderFns } from "./add-edit-user.vue?vue&type=template&id=870280d8&scoped=true&"
import script from "./add-edit-user.vue?vue&type=script&lang=js&"
export * from "./add-edit-user.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-user.vue?vue&type=style&index=0&id=870280d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870280d8",
  null
  
)

component.options.__file = "add-edit-user.vue"
export default component.exports